import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full h-full ion-padding" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, " Nuova versione dell'app ", -1)
const _hoisted_3 = { class: "text-center ion-padding-vertical" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, { fullscreen: "" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ion_grid, { class: "flex flex-column h-full justify-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_row, { center: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, { width: "100" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card, { class: "limit-card" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_header, { class: "text-center" }, {
                          default: _withCtx(() => [
                            _hoisted_2
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_card_content, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.messageMinVersion), 1),
                            _createVNode(_component_ion_button, {
                              class: "w-full",
                              onClick: _ctx.redirectToStore
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Aggiorna ")
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}